/**
 * Gets the page path for the tco sub pages under /tco/<assessment id>
 * Returned string will start with backslash
 * @param locationPath the full pathname
 * @returns 
 */
export const getTcoSubPage = (locationPath: string): string => {
    const locationParts = locationPath.split('/');
    const tcoIndex = locationParts.findIndex(locationPart => locationPart === 'tco');
    if (tcoIndex < 0 || tcoIndex >= locationParts.length - 2) {
        return '/summary';
    }
    const currentPage = locationParts.reduce((page, part, index) => {
        if (index > tcoIndex + 1) {
            page = `${page}/${part}`;
        }
        return page;
    }, '');
    return currentPage;
};
